(function () {
  // Prevent cart.js initCartShippingProtection from adding the wrong variant first
  window.localStorage.setItem('ecomify-shipping-protection-init', 'true');

  const getConfig = () => document.getElementById('shipping-protection-config');

  const getCart = () =>
    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());

  const isProtectionItem = (item, config) =>
    item.handle === config.dataset.productHandle ||
    (item.product_title && item.product_title.includes('Shipping Protection'));

  const getCartSubtotalExcludingProtection = (cart, config) =>
    cart.items.reduce((total, item) => {
      if (isProtectionItem(item, config)) return total;
      return total + item.final_line_price;
    }, 0);

  const getTargetVariantId = (cart, config) => {
    const threshold = Number(config.dataset.thresholdCents);
    const subtotal = getCartSubtotalExcludingProtection(cart, config);
    return subtotal >= threshold
      ? config.dataset.highVariantId
      : config.dataset.lowVariantId;
  };

  const hasOtherCartItems = (cart, config) =>
    cart.items.some((item) => !isProtectionItem(item, config));

  const updateCheckboxVariant = (variantId, lineItemKey) => {
    const checkbox = document.getElementById('cart-shipping-protection-checkbox');
    if (!checkbox) return;
    checkbox.value = variantId;
    if (lineItemKey) {
      checkbox.setAttribute('data-line-item-key', lineItemKey);
    } else {
      checkbox.removeAttribute('data-line-item-key');
    }
  };

  let initialSyncDone = false;

  const setProtectionVisible = (visible) => {
    if (visible) {
      document.body.classList.add('shipping-protection-ready');
    } else {
      document.body.classList.remove('shipping-protection-ready');
    }
  };

  const syncShippingProtection = async () => {
    const config = getConfig();
    if (!config || config.dataset.enabled !== 'true') {
      setProtectionVisible(true);
      return;
    }

    if (window.addingShippingProtection) return;

    const cart = await getCart();
    const targetVariantId = getTargetVariantId(cart, config);
    const autoAdd = config.dataset.autoAdd === 'true';
    const protectionItem = cart.items.find((item) => isProtectionItem(item, config));
    const needsVariantSwap =
      protectionItem &&
      protectionItem.variant_id.toString() !== targetVariantId.toString();

    if (needsVariantSwap) {
      setProtectionVisible(false);
    }

    if (protectionItem) {
      updateCheckboxVariant(targetVariantId, protectionItem.key);
      const checkbox = document.getElementById('cart-shipping-protection-checkbox');
      if (checkbox) checkbox.checked = true;

      if (needsVariantSwap) {
        window.addingShippingProtection = true;
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: protectionItem.key, quantity: 0 }),
          });
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(targetVariantId), quantity: 1 }] }),
          });
          if (typeof window.refreshCartContents === 'function') {
            await window.refreshCartContents(addResponse.clone());
          }
        } finally {
          window.addingShippingProtection = false;
        }
      }
      if (!initialSyncDone) initialSyncDone = true;
      setProtectionVisible(true);
      return;
    }

    const checkbox = document.getElementById('cart-shipping-protection-checkbox');
    if (checkbox) {
      checkbox.checked = false;
      updateCheckboxVariant(targetVariantId);
    }

    if (autoAdd && hasOtherCartItems(cart, config)) {
      window.addingShippingProtection = true;
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(targetVariantId), quantity: 1 }] }),
        });
        if (typeof window.refreshCartContents === 'function') {
          await window.refreshCartContents(addResponse.clone());
        }
      } finally {
        window.addingShippingProtection = false;
      }
    }

    if (!initialSyncDone) initialSyncDone = true;
    setProtectionVisible(true);
  };

  window.onChangeCartShippingProtection = async (input) => {
    const config = getConfig();
    const cart = await getCart();
    const targetVariantId = config
      ? getTargetVariantId(cart, config)
      : input.value;

    let response;
    if (input.checked) {
      response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ quantity: 1, id: Number(targetVariantId) }] }),
      });
    } else {
      response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: input.dataset.lineItemKey, quantity: 0 }),
      });
    }

    if (typeof window.refreshCartContents === 'function') {
      window.refreshCartContents(response);
    }
  };

  const init = () => {
    syncShippingProtection();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('updated.ecomify.cart', () => {
    syncShippingProtection();
  });
})();
